import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-login-layout',
  imports: [RouterModule],
  templateUrl: './login-layout.component.html',
})
export class LoginLayoutComponent {}
